/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_tooltip_avg_pos_track = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Average finishing position by circuit category - lower is better`)
};

const es_f1_profile_tooltip_avg_pos_track = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición promedio de llegada por categoría de circuito - menor es mejor`)
};

const de_f1_profile_tooltip_avg_pos_track = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchschnittliche Zielposition nach Streckenkategorie — niedriger ist besser`)
};

const nl_f1_profile_tooltip_avg_pos_track = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemiddelde finishpositie per circuitcategorie — lager is beter`)
};

const fr_f1_profile_tooltip_avg_pos_track = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position d’arrivée moyenne par catégorie de circuit — plus bas est mieux`)
};

const it_f1_profile_tooltip_avg_pos_track = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione media di arrivo per categoria circuito — più basso è meglio`)
};

const pt_br2_f1_profile_tooltip_avg_pos_track = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição média de chegada por categoria de circuito — menor é melhor`)
};

const pt_f1_profile_tooltip_avg_pos_track = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição média de chegada por categoria de circuito — menor é melhor`)
};

const ja_f1_profile_tooltip_avg_pos_track = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サーキットカテゴリ別の平均フィニッシュポジション — 低い方が良い`)
};

const zh_f1_profile_tooltip_avg_pos_track = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按赛道类别的平均完赛名次 — 越低越好`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_tooltip_avg_pos_track = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_tooltip_avg_pos_track(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_tooltip_avg_pos_track", locale)
	if (locale === "en") return en_f1_profile_tooltip_avg_pos_track(inputs)
	if (locale === "es") return es_f1_profile_tooltip_avg_pos_track(inputs)
	if (locale === "de") return de_f1_profile_tooltip_avg_pos_track(inputs)
	if (locale === "nl") return nl_f1_profile_tooltip_avg_pos_track(inputs)
	if (locale === "fr") return fr_f1_profile_tooltip_avg_pos_track(inputs)
	if (locale === "it") return it_f1_profile_tooltip_avg_pos_track(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_tooltip_avg_pos_track(inputs)
	if (locale === "pt") return pt_f1_profile_tooltip_avg_pos_track(inputs)
	if (locale === "ja") return ja_f1_profile_tooltip_avg_pos_track(inputs)
	return zh_f1_profile_tooltip_avg_pos_track(inputs)
};